import React, { FC, useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { menuMobx } from 'restaurant'
import { handleEleScrollTo } from '@utils'
import './index.scss'

// interface
interface IProps {
  // scrollTo?({ toTop, scrollTop, duration }: { toTop?: boolean; scrollTop?: number; duration?: number }): void;
}
const colorMap = ['#7ED321', '#2690E9', '#50E3C2', '#B6885F', '#8E959F', '#F5A623']
const CategoryBtns: FC<IProps> = ({ }) => {
  const { categories, selectCategory, selectCategoryNo } = menuMobx
  // 选择分类
  const handleSelectCategory = function (no?: string) {
    selectCategory(no)
    const menuListContent = document.querySelector('.product-template') as any
    let offsetTop = menuListContent?.offsetTop || 0
    if (offsetTop >= 56) {
      offsetTop = offsetTop - 56
    }
    handleEleScrollTo?.({ y: offsetTop })
  }
  return (
    <>
      {
        categories.length ? (
          <div className='category-btns-container'>
            <p>{i18n.t('menu.category')}</p>
            <div className='categories-btn-list'>
              {
                selectCategoryNo ? (
                  <div
                    className='category-btn-item'
                    // style={{ background: colorMap[0] }}
                    onClick={() => handleSelectCategory()}
                  >{i18n.t('common.all')}
                  </div>
                ) : null
              }
              {
                categories.map(({ no, name }, index) => {
                  index = selectCategoryNo ? index + 1 : index
                  return (
                    <div
                      key={no}
                      className='category-btn-item'
                      // style={{ background: colorMap[index <= 5 ? index : index % 6] }}
                      onClick={() => handleSelectCategory(no)}
                    >{name}
                    </div>
                  )
                })
              }
            </div>
          </div>
        ) : null
      }
    </>
  )
}

export default observer(CategoryBtns)
